'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'file-half-dashed';
var width = 384;
var height = 512;
var aliases = [];
var unicode = 'e698';
var svgPathData = ['M0 64C0 28.7 28.7 0 64 0l160 0 0 128c0 17.7 14.3 32 32 32l128 0 0 160-384 0 0-256z', 'M265 17C254.1 6.1 239.4 0 224 0l0 128c0 17.7 14.3 32 32 32l128 0c0-15.4-6.1-30.1-17-41L265 17zM0 352l0 64 64 0 0-64-64 0zM64 512l0-64-64 0c0 35.3 28.7 64 64 64zm32 0l80 0 0-64-80 0 0 64zm112 0l80 0 0-64-80 0 0 64zm112 0c35.3 0 64-28.7 64-64l-64 0 0 64zm64-160l-64 0 0 64 64 0 0-64z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFileHalfDashed = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;